import { render, staticRenderFns } from "./OSalesView.vue?vue&type=template&id=4b2672f1&"
import script from "./OSalesView.vue?vue&type=script&lang=js&"
export * from "./OSalesView.vue?vue&type=script&lang=js&"
import style0 from "./OSalesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports